import React from 'react'
import { graphql, gql, withApollo, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import _ from 'lodash'

import { translate } from 'react-i18next'

import Form from '../../UI/Form'
import LocationInput from '../../UI/LocationInput'
import { validateRequired } from '../../../libs/validation'
import { geoSuggestToLocation, locationToGeoSuggest } from '../../../libs/utils'
import { NotificationManager } from 'react-notifications'
import Loader from '../../UI/Loader'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'

const GettingStartedGoogleMap = withGoogleMap(props => (
  <GoogleMap ref={props.onMapLoad} defaultZoom={4} center={props.location} onClick={props.onMapClick}>
    {props.markers.map((marker, index) => <Marker {...marker} onRightClick={() => props.onMarkerRightClick(index)} />)}
  </GoogleMap>
))

class LocationForm extends React.Component {
  state = {
    saving: false,
    routeIndex: 2,
    markers: [
      {
        position: {
          lat: 25.0112183,
          lng: 121.52067570000001
        },
        key: `Taiwan`,
        defaultAnimation: 2
      }
    ]
  }

  componentWillMount() {
    const location = _.get(this, 'props.data.User.userProfile.location')
    if (location) {
      this.geoLocation = locationToGeoSuggest(location)
      this.setState({
        markers: [
          {
            position: {
              lat: location.lat,
              lng: location.lng
            },
            key: location.googleId,
            defaultAnimation: 2
          }
        ]
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    const location = _.get(this, 'props.data.User.userProfile.location')
    const newLocation = _.get(nextProps, 'data.User.userProfile.location')
    if (!location && newLocation) {
      this.geoLocation = locationToGeoSuggest(newLocation)
      this.setState({
        markers: [
          {
            position: {
              lat: newLocation.lat,
              lng: newLocation.lng
            },
            key: newLocation.googleId,
            defaultAnimation: 2
          }
        ]
      })
    }
  }

  handleSubmit = values => {  
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true
    })
    const location = geoSuggestToLocation(values.location)
   
    const locationQuery = gql`
      query locationQuery($googleId: String!) {
        allLocations(filter: { googleId: $googleId }) {
          id
        }
      }
    `
    this.props.client
      .query({
        query: locationQuery,
        variables: {
          googleId: location.googleId
        }
      })
      .then(result => {
        if (result.data.allLocations.length) {
          return this.props.updateUserProfile({
            variables: {
              id: this.props.data.User.userProfile.id,
              location: result.data.allLocations[0].id
            }
          })
        } else {
          return this.props.createLocation({
            variables: {
              id: this.props.data.User.userProfile.id,
              location
            }
          })
        }
      })
      .then(result => {
        this.props.data.refetch()
        NotificationManager.success('Location updated', 'Success', 5000)
        this.setState({
          saving: false
        })
        this.props.history.push('/create-guru-profile/photos')
      })
      .catch(err => {
        this.setState({
          saving: false
        })
        NotificationManager.error('Error while updating locations', 'Error', 5000)
      })
  }

  handleLocationChange = (name, value) => {
    const { location: { lat, lng }, label } = value
    this.setState({
      markers: [
        {
          position: {
            lat,
            lng
          },
          key: label,
          defaultAnimation: 2
        }
      ]
    })
  }

  render() {
    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { t } = this.props
    const { saving, markers } = this.state
    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">My Location</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area row">
            <div className="form-group clearfix">
              <div className="col-md-12">
                <div className="steps-screen__form-subtitle">{t('home_location_title')}</div>
                <LocationInput
                  id="location"
                  placeholder={t('example_location')}
                  initialValue={this.geoLocation}
                  validationFuncs={[validateRequired]}
                  onChangeExternal={this.handleLocationChange}
                  isGroup={false}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="google-map-wrapper">
                <GettingStartedGoogleMap
                  containerElement={<div style={{ height: `100%` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                  onMapLoad={_.noop}
                  onMapClick={_.noop}
                  markers={markers}
                  location={markers[0].position}
                  onMarkerRightClick={_.noop}
                />
              </div>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const updateUserProfile = gql`
  mutation updateUserProfile($id: ID!, $location: ID!) {
    updateUserProfile(id: $id, locationId: $location) {
      id
      location {
        id
      }
    }
  }
`

const createLocation = gql`
  mutation updateUserProfileAndCreateLocation($id: ID!, $location: UserProfilelocationLocation) {
    updateUserProfile(id: $id, location: $location) {
      id
      location {
        id
      }
    }
  }
`

const TranslatedLocationForm = translate('guru')(LocationForm)

export default compose(
  graphql(createLocation, { name: 'createLocation' }),
  graphql(updateUserProfile, { name: 'updateUserProfile' }),
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  })
)(withRouter(withApollo(TranslatedLocationForm)))



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/LocationForm.jsx